import { t } from "@alluzo/shared"
import { Loader2Icon } from "lucide-react"

import { cn } from "~/lib/utils"

/**
 * The kit's spinner: muted, one turn a second. It says "Loading" to a screen
 * reader; inside a busy button it is hidden, because the button says it.
 */
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label={t("common.loading")}
      className={cn("size-4 animate-spin text-muted-foreground", className)}
      {...props}
    />
  )
}

export { Spinner }
